import { Component, Input, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectHelper } from '@app/app/page-modules/resource/store/editor/content/helpers/redirect.helper';
import { resolveContentEntityType } from '@app/app/shared/helpers/content-entity-type.helper';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { CardsLayoutType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-collection-cards-view',
  templateUrl: './collection-cards-view.component.html',
  styleUrls: ['./collection-cards-view.component.scss'],
})
export class CollectionCardsViewComponent {
  @Input() cards: PlaylistCardShort[] = [];
  @Input() currentLayoutView: CardsLayoutType = 'CardView';

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
  ) {}

  onCardClick(card: PlaylistCardShort): void {
    const uri = NestedPathHelper.resolveCardSlug(card);
    if (!uri) {
      return;
    }

    const currentUrl = this.router.url.split('?')[0];
    const entityType = resolveContentEntityType(card);

    // Assignment cards open their own view at the bare nested URL (no tab suffix).
    if (entityType === 'assignment') {
      const assignmentPath = NestedPathHelper.buildPathForEntity('assignment', uri, NestedPathHelper.getAllSegments(currentUrl));
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, assignmentPath);
      return;
    }

    // Outside a nested path this yields the entity's own top-level route.
    const newPath = NestedPathHelper.addEntityToPath(currentUrl, entityType, uri, 'content');
    RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newPath);
  }
}
